import { Injectable } from '@angular/core';

export interface IFormField {
  id: string;
  type: string;
  pageNumber: number;
  xRel: number;       
  yRel: number;       
  widthRel: number;   
  heightRel: number;  
  value?: any;
}

export interface PdfLibCoordinates {
  x: number;
  y: number; 
  width: number;
  height: number;
}

@Injectable({
  providedIn: 'root'
})
export class PdfCoordinateService {

  constructor() { }

  screenToRelative(
    screenX: number,
    screenY: number,
    screenWidth: number,
    screenHeight: number,
    pageElementWidthPx: number,
    pageElementHeightPx: number,
    zoomScale: number = 1
  ): { xRel: number, yRel: number, widthRel: number, heightRel: number } {
    
    const basePageWidth = pageElementWidthPx / zoomScale;
    const basePageHeight = pageElementHeightPx / zoomScale;

    const baseScreenX = screenX / zoomScale;
    const baseScreenY = screenY / zoomScale;
    const baseScreenWidth = screenWidth / zoomScale;
    const baseScreenHeight = screenHeight / zoomScale;

    return {
      xRel: this.roundToDecimals(baseScreenX / basePageWidth, 4),
      yRel: this.roundToDecimals(baseScreenY / basePageHeight, 4),
      widthRel: this.roundToDecimals(baseScreenWidth / basePageWidth, 4),
      heightRel: this.roundToDecimals(baseScreenHeight / basePageHeight, 4)
    };
  }

  relativeToPdfLib(
    field: IFormField,
    pdfPageWidthPoints: number,
    pdfPageHeightPoints: number
  ): PdfLibCoordinates {

    const exactWidth = field.widthRel * pdfPageWidthPoints;
    const exactHeight = field.heightRel * pdfPageHeightPoints;

    const exactX = field.xRel * pdfPageWidthPoints;
    const exactYFromTop = field.yRel * pdfPageHeightPoints;

    const invertedY = pdfPageHeightPoints - exactYFromTop - exactHeight;

    return {
      x: Math.round(exactX * 100) / 100, 
      y: Math.round(invertedY * 100) / 100,
      width: Math.round(exactWidth * 100) / 100,
      height: Math.round(exactHeight * 100) / 100
    };
  }
  calculateDragEndRelative(
    currentRelativeX: number,
    currentRelativeY: number,
    dragDeltaPxX: number,
    dragDeltaPxY: number,
    pageElementWidthPx: number,
    pageElementHeightPx: number,
    zoomScale: number = 1
  ): { xRel: number, yRel: number } {
    const basePageWidth = pageElementWidthPx / zoomScale;
    const basePageHeight = pageElementHeightPx / zoomScale;
    
    const deltaRelX = (dragDeltaPxX / zoomScale) / basePageWidth;
    const deltaRelY = (dragDeltaPxY / zoomScale) / basePageHeight;

    const newRelativeX = Math.max(0, Math.min(1, currentRelativeX + deltaRelX));
    const newRelativeY = Math.max(0, currentRelativeY + deltaRelY);

    return {
      xRel: this.roundToDecimals(newRelativeX, 4),
      yRel: this.roundToDecimals(newRelativeY, 4)
    };
  }
  
  private roundToDecimals(num: number, decimals: number): number {
    const factor = Math.pow(10, decimals);
    return Math.round(num * factor) / factor;
  }

}
